<div class="models-wrapper">

    <div class="filter-bar">
        <p-iconfield class="filter-search">
            <p-inputicon><img src="assets/icons/search.svg" alt="search icon" /></p-inputicon>
            <input type="text" pInputText placeholder="Search by plate, VIN, maker, model..."
                class="w-full search-bar" [formControl]="searchControl" />
        </p-iconfield>

        <div class="filter-chips">
            <button class="chip" [class.chip--active]="isAllActive" (click)="clearAll()">All</button>

            <p-multiSelect class="multi-select" [options]="bodyTypeOptions" placeholder="Body type"
                [formControl]="bodyTypeControl" [showClear]="true"></p-multiSelect>

            <p-select class="multi-select" [options]="rentalTypeOptions" placeholder="Rental type"
                [formControl]="rentalTypeControl" [showClear]="true"></p-select>
        </div>
    </div>

    <div class="model-grid">
        @for (model of models(); track model.id) {
        <div class="model-card">
            <!-- Covers the whole card; the action buttons sit above it, outside the link. -->
            <a class="model-card__link" [routerLink]="['/models', model.id]"
                [attr.aria-label]="model.maker + ' ' + model.name"></a>

            <div class="model-card__image">
                <img [src]="model.imageUrl" [alt]="model.name" />
            </div>

            <div class="model-card__body">
                <div class="model-card__header">
                    <span class="model-card__name">{{ model.maker }} {{ model.name }}</span>
                    @if (model.carCount !== null) {
                    <span class="model-card__badge">
                        <span class="model-card__dot"></span>{{ model.carCount }} cars
                    </span>
                    }
                </div>

                <div class="model-card__meta">
                    <span class="model-card__subtitle">ID: {{ model.id }} · {{ model.bodyType }}</span>
                    @if ([UserRole.ADMIN, UserRole.FLEET_MANAGER,
                    UserRole.SUPER_ADMIN].includes(employee()?.role!)) {
                    <div class="model-card__actions">
                        <button class="action-btn" (click)="updateModel(model)">
                            <img src="assets/icons/edit.svg" alt="edit" />
                        </button>
                        <button class="action-btn action-btn--delete" (click)="openDeleteModelDialog(model)">
                            <img src="assets/icons/delete.svg" alt="delete" />
                        </button>
                    </div>
                    }
                </div>

                <div class="model-card__stats">
                    <div class="stat">
                        <span class="stat__label">SEATS</span>
                        <span class="stat__value">{{ model.seats }}</span>
                    </div>
                    <div class="stat align-items-end">
                        <span class="stat__label">POWER</span>
                        <span class="stat__value">{{ model.horsepower }} hp</span>
                    </div>
                    <div class="stat">
                        <span class="stat__label">STARTING FEE</span>
                        <span class="stat__value">AED {{ model.startingFee | number:'1.2-2' }}</span>
                    </div>
                    <div class="stat align-items-end">
                        <span class="stat__label">PER KM</span>
                        <span class="stat__value">AED {{ model.overageRatePerKm | number:'1.2-2' }}</span>
                    </div>
                </div>
            </div>

        </div>
        }
    </div>

    <div class="models-footer">
        <span class="models-footer__info">Showing {{ models().length }} of {{ totalRecords() }}</span>
        <p-paginator [first]="first" [rows]="pageSize" [totalRecords]="totalRecords()"
            [rowsPerPageOptions]="[20, 30, 50]" (onPageChange)="onPageChange($event)" />
    </div>

</div>

@defer (when deleteModelDialog; prefetch on idle) {
<app-delete-model-form (deletedModel)="onModelDeleted()" [selectedModel]="selectedModel"
    [(visibility)]="deleteModelDialog" />
}
